export const DOCUMENTS_ROOT_PATH = '/documents';
export const COLLECTION_PATH = `${DOCUMENTS_ROOT_PATH}/collection`;
export const UPLOAD_PATH = `${DOCUMENTS_ROOT_PATH}/upload`;
export const CONFIDENTIALITY_UPLOAD_PATH = `${UPLOAD_PATH}/cdph_confidentiality_consent`;
